import { render, staticRenderFns } from "./VideoHeroSection.vue?vue&type=template&id=7411312a&scoped=true&"
import script from "./VideoHeroSection.vue?vue&type=script&lang=ts&"
export * from "./VideoHeroSection.vue?vue&type=script&lang=ts&"
import style0 from "./VideoHeroSection.vue?vue&type=style&index=0&id=7411312a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7411312a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Video: require('/opt/build/repo/apps/shop/components/storyblok/Video/Video.vue').default})
